export const STREET_LIGHT_GENERATION = {
    OLD: "old",
    NEW: "new",
};
export const STREET_LIGHT_TYPE_LIST = [
    { key: "MERCURY_VAPOUR_HIGH_PRESSURE", generation: "old", consumptionKwhPerHour: 0.125 },
    { key: "SODIUM_VAPOUR_HIGH_PRESSURE", generation: "old", consumptionKwhPerHour: 0.106 },
    { key: "METAL_HALIDE", generation: "old", consumptionKwhPerHour: 0.106 },
    { key: "SODIUM_VAPOUR", generation: "new", consumptionKwhPerHour: 0.056 },
    { key: "METAL_HALIDE_NEW", generation: "new", consumptionKwhPerHour: 0.056 },
    { key: "LED", generation: "new", consumptionKwhPerHour: 0.038 },
];
const hasGeneration = (generation) => (type) => type.generation === generation;
export const STREET_LIGHT_TYPE_KEY_LIST = STREET_LIGHT_TYPE_LIST.map((type) => type.key);
export const OLD_STREET_LIGHT_TYPE_KEY_LIST = STREET_LIGHT_TYPE_LIST.filter(hasGeneration(STREET_LIGHT_GENERATION.OLD)).map((type) => type.key);
export const NEW_STREET_LIGHT_TYPE_KEY_LIST = STREET_LIGHT_TYPE_LIST.filter(hasGeneration(STREET_LIGHT_GENERATION.NEW)).map((type) => type.key);
export const CONSUMPTION_KWH_PER_HOUR_BY_TYPE = Object.fromEntries(STREET_LIGHT_TYPE_LIST.map((type) => [type.key, type.consumptionKwhPerHour]));
export function computeStockConsumptionKwhPerHour(stockCountByType) {
    return STREET_LIGHT_TYPE_LIST.reduce((sum, type) => sum + stockCountByType[type.key] * type.consumptionKwhPerHour, 0);
}
